import { FaArrowRight } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";

const ViewYourWallet = () => {
  const navigate = useNavigate();

  const handleNavigate = useCallback(() => {
    navigate("/billing/walletTransaction");
  }, [navigate]);

  return (
    <div
      className="flex justify-between items-center p-4 w-full bg-secondary/5 rounded-xl border border-black/15 
                 cursor-pointer hover:bg-secondary/10 transition-colors duration-200"
      onClick={handleNavigate}
      role="button"
      tabIndex="0"
      onKeyDown={(e) => e.key === "Enter" && handleNavigate()}
      aria-label="View Wallet Transactions"
    >
      <p className="text-headline5 text-secondary/90 font-nunito">
        View your Wallet Transactions
      </p>
      <FaArrowRight className="text-subtitle1 text-secondary/80" />
    </div>
  );
};

export default ViewYourWallet;
